<cas-button materialIcon="reply_all" btnClass="md-raised md-accent" (clickAction)="toggle()" btnText="Copy To"></cas-button>

<mat-card [formGroup]="copyToForm" class="copy-to-control-area" *ngIf="isVisible">
    <div>Select RTU(s) to Copy Schedule To:</div>

    <div fxLayout="row">
        <mat-form-field fxFlex>
            <mat-select [formControl]="formControl" multiple>
                <mat-option *ngFor="let rtu of nonSelectedRtus" [value]="rtu.id">
                    {{ rtu.text }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <cas-button btnClass="md-accent md-raised" materialIcon="reply_all" (clickAction)="submit()" [disabled]="selectedRtus.length === 0" btnText="Copy and overwrite schedule{{ selectedRtus.length > 1 ? 's' : '' }}"></cas-button>
    <cas-button btnClass="md-accent md-raised" (clickAction)="toggle()" btnText="Close"></cas-button>
</mat-card>
